// extracted by mini-css-extract-plugin
export default {"container":"errorboundary_container__b5pmo"};